import React, { createContext, useContext } from "react";

import { EnvCtx } from "./global-env-ctx";
import type { EnvironmentContext } from "./service/types";

const EnvironmentContext = createContext<EnvironmentContext | undefined>(
  undefined,
);

export function EnvironmentProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <EnvironmentContext.Provider value={EnvCtx}>
      {children}
    </EnvironmentContext.Provider>
  );
}

export function useEnvironmentContext() {
  const context = useContext(EnvironmentContext);
  if (!context) {
    throw new Error(
      "useEnvironmentContext must be used within an EnvironmentProvider",
    );
  }
  return {
    ...context,
    isDesktop: context.surface === "desktop",
    isDarwin: context.platform === "darwin",
  };
}
